import { TravelFormState } from "@/app/stores/travel/travel-comparator.store"

export type TravelLandingPreset = Partial<Pick<TravelFormState, "motif" | "destinationCountries">>

const LANDING = "/guide/assurance-voyage"

// Flag on: a guide page listed here swaps its WordPress hero and Auctor comparator for the travel hero card.
export const TRAVEL_LANDING_PRESETS: Record<string, TravelLandingPreset> = {
    [LANDING]: {},
    [`${LANDING}/algerie`]: { destinationCountries: ["DZ"] },
    [`${LANDING}/annuelle`]: {},
    [`${LANDING}/annulation-vol`]: {},
    [`${LANDING}/asie`]: {},
    [`${LANDING}/au-pair`]: {},
    [`${LANDING}/australie`]: { destinationCountries: ["AU"] },
    [`${LANDING}/canada`]: { destinationCountries: ["CA"] },
    [`${LANDING}/court-sejour`]: {},
    [`${LANDING}/covid`]: {},
    [`${LANDING}/europe`]: {},
    [`${LANDING}/expatrie`]: { motif: "expatriation" },
    [`${LANDING}/groupe`]: {},
    [`${LANDING}/japon`]: { destinationCountries: ["JP"] },
    [`${LANDING}/longue-duree`]: {},
    [`${LANDING}/maroc`]: { destinationCountries: ["MA"] },
    [`${LANDING}/prix`]: {},
    [`${LANDING}/pvt`]: { motif: "working_holiday" },
    [`${LANDING}/thailande`]: { destinationCountries: ["TH"] },
    [`${LANDING}/tour-du-monde`]: {},
    [`${LANDING}/usa`]: { destinationCountries: ["US"] },
}
